(() => {
  let timer;
  let busy = false;
  const inputSelector = '[data-gk-cart-page] input[data-line-key]';
  async function updateCart(root, key, quantity) {
    clearTimeout(timer);
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    root.setAttribute('aria-busy', 'true');
    const controls = [...root.querySelectorAll('input[data-line-key], button[name="checkout"], button[type="submit"]')];
    const enabled = controls.filter(control => !control.disabled);
    enabled.forEach(control => control.disabled = true);
    const note = root.querySelector('[name="note"]')?.value;
    const error = root.querySelector('[data-gk-cart-error]');
    error.hidden = true;
    try {
      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: key, quantity, sections: [root.dataset.sectionId], sections_url: window.location.pathname})
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || root.dataset.cartError);
      const html = cart.sections?.[root.dataset.sectionId];
      if (!html) { window.location.reload(); return; }
      const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gk-cart-page]');
      if (!replacement) { window.location.reload(); return; }
      root.replaceWith(replacement);
      if (note !== undefined && replacement.querySelector('[name="note"]')) replacement.querySelector('[name="note"]').value = note;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'line-item:change', cart}}));
      const field = [...replacement.querySelectorAll('input[data-line-key]')].find(input => input.dataset.lineKey === key && input.getClientRects().length);
      field?.focus({preventScroll: true});
    } catch (failure) {
      error.textContent = failure.message || root.dataset.cartError;
      error.hidden = false;
      root.querySelectorAll('input[data-line-key]').forEach(input => input.value = input.defaultValue);
    } finally {
      busy = false;
      root.removeAttribute('aria-busy');
      enabled.forEach(control => control.disabled = false);
    }
  }
  for (const name of ['input', 'change']) document.addEventListener(name, event => {
    if (!event.target.matches(inputSelector)) return;
    event.stopImmediatePropagation();
    clearTimeout(timer);
    const input = event.target;
    const apply = () => { if (input.value.trim() !== '') updateCart(input.closest('[data-gk-cart-page]'), input.dataset.lineKey, Number(input.value)); };
    if (name === 'change') apply();
    else timer = setTimeout(apply, 400);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-gk-cart-page] line-item-quantity a[href]');
    if (!link) return;
    const url = new URL(link.href);
    if (!url.pathname.endsWith('/cart/change') || !url.searchParams.has('id')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    updateCart(link.closest('[data-gk-cart-page]'), url.searchParams.get('id'), Number(url.searchParams.get('quantity')));
  }, true);
})();
